import { IWindowService } from 'angular';
import UserService from './user/user.service';

/* @ngInject */
export default class TokenRedirectService {
  private readonly applicationRefreshToken = 'otp_rtkn';
  private readonly rtknPrefix = 'Bearer ';
  constructor(
    private $cookies,
    private $window: IWindowService,
    private config,
    private userService: UserService,
    private i18n
  ) {}

  public openPlayer() {
    let webPlayer = this.config.webPlayer[
      this.userService.getTerritory().toLowerCase()
    ];
    let rtkn = undefined; //;this.$cookies.get(this.applicationRefreshToken);
    webPlayer =
      webPlayer +
      (webPlayer.indexOf('?') !== -1
        ? '&language=' + this.i18n.getCurrentLanguage()
        : '?language=' + this.i18n.getCurrentLanguage()) +
      (rtkn ? '&rtkn=' + this.rtknPrefix + rtkn : '');

    this.$window.open(webPlayer, '_blank');
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/token-redirect.service.ts